import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('admin-token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/admin/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setAdmin(response.data);
        } catch (error) {
          localStorage.removeItem('admin-token');
          setToken(null);
          setAdmin(null);
        }
      }
      setLoading(false);
    };

    verifyToken();
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/admin/login`, { email, password });
    const newToken = response.data.access_token;
    localStorage.setItem('admin-token', newToken);
    setToken(newToken);
    
    const adminResponse = await axios.get(`${API}/admin/me`, {
      headers: { Authorization: `Bearer ${newToken}` }
    });
    setAdmin(adminResponse.data);
    
    return adminResponse.data;
  };

  const logout = () => {
    localStorage.removeItem('admin-token');
    setToken(null);
    setAdmin(null);
  };

  const getAuthHeader = () => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <AuthContext.Provider value={{
      admin,
      token,
      loading,
      login,
      logout,
      getAuthHeader,
      isAuthenticated: !!admin
    }}>
      {children}
    </AuthContext.Provider>
  );
};
